module.exports = __webpack_public_path__ + "img/@tmp_course_thumbnail_02.0c78fe4e.jpg";